<style lang="stylus">
// Card look (background/border/padding/radius/shadow) comes from the shared .auth-card
// class in public/css/main.css; this rule only adds this section's own layout.
.welcome-login-section {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.welcome-login-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.72px;
  color: #000;
  margin: 0;
}

.welcome-login-intro {
  font-size: 18px;
  color: #666;
  text-align: center;
  margin-bottom: 24px;
}

.login-button-with-asurite {
  text-align: center;
  width: 100%;
}

.login-mytooltip .login-mytext {
  font-size: 14px;
  font-weight: bold;
  visibility: hidden;
  background-color: black;
  color: #fff;
  z-index: 1;
  top: 160%;
  left: -16%;
  margin-left: -90px;
  text-align: center;
  border-radius: 6px;
  padding: 12px 6px;
  position: absolute;
}

.login-mytooltip {
  font-weight: bold;
  position: relative;
  display: inline-block;
}

.login-mytooltip .login-mytext:after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -10px;
  border-width: 7px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

.login-mytooltip:hover .login-mytext {
  visibility: visible;
}

@media (min-width: 300px) and (max-width: 320px) {
  .login-mytooltip .login-mytext {
    width: 288px;
    left: 2%;
    padding: 17px 10px;
  }

  .login-mytooltip .login-mytext:after {
    left: 50%;
  }
}

@media (min-width: 321px) and (max-width: 385px) {
  .login-mytooltip .login-mytext {
    width: 331px;
    left: -8%;
    padding: 17px 10px;
  }

  .login-mytooltip .login-mytext:after {
    left: 50%;
  }
}

@media (min-width: 386px) and (max-width: 480px) {
  .login-mytooltip .login-mytext {
    width: 338px;
    left: -9%;
    padding: 17px 10px;
  }

  .login-mytooltip .login-mytext:after {
    left: 50%;
  }
}

@media (min-width: 481px) and (max-width: 620px) {
  .login-mytooltip .login-mytext {
    width: 288px;
    left: 35%;
    padding: 17px 10px;
  }

  .login-mytooltip .login-mytext:after {
    left: 38%;
  }
}

@media (min-width: 620px) {
  .login-mytooltip .login-mytext {
    width: 375px;
  }
}
</style>
<template>
  <v-container class="containerFixedHeight d-flex align-center justify-center">
    <v-row align-center justify="center" wrap style="margin: 3rem auto 5rem auto; max-width: 600px">
      <v-col cols="12" v-if="welcomePageTitle">
        <div class="welcome-header-mobile d-flex d-sm-none justify-center">
          <span style="background-color: #ffc627; padding: 0 5px">{{ welcomePageTitle }}</span>
        </div>
        <div class="welcome-header d-none d-sm-flex justify-center">
          <span style="background-color: #ffc627; padding: 0 5px">{{ welcomePageTitle }}</span>
        </div>
      </v-col>

      <v-col cols="12" style="max-width: 500px">
        <div class="welcome-login-intro" v-html="intro" />
      </v-col>

      <v-col cols="12" style="max-width: 500px; margin-top: 48px">
        <div class="welcome-login-section auth-card">
          <h2 class="welcome-login-title">Sign in</h2>

          <div class="login-button-with-asurite">
            <Button @click="login" variant="gold" rounded size="large" block> Sign in with ASURITE </Button>
            <div style="text-align: center">
              <div class="what-asurite-link login-mytooltip">
                <a>What is an ASURITE ID?</a>
                <span class="login-mytext"
                  >When you join ASU as a student, faculty or staff, you receive an ASURITE ID. This is your unique ASU
                  login credential.</span
                >
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';

import { FetchPartnerData } from '../mixins/fetchPartnerDataMixin';
import { Helper } from '../mixins/helpers.js';
import Button from './ui/Button.vue';

export default defineComponent({
  components: { Button },
  mixins: [FetchPartnerData],

  data() {
    return {
      intro: ''
    };
  },

  methods: {
    login() {
      this.logInfo('calling asurite authentication');

      this.$auth.login('asurite');
    },
    introText() {
      const customIntroTextUlc =
        'Jumpstart your path to higher education with Universal Learner Courses from Arizona State University.';
      const customIntroTextEa =
        'Jumpstart your path to higher education with Earned Admission courses from Arizona State University.';

      const isULCDomain = Helper.methods.isUlcPartner();
      const partnerName = this.$conn.getPartnerName();

      if (!isULCDomain) {
        // 'accelerate' dropped: WelcomeDesktop.vue now always routes accelerate to
        // CreateLearnerComponentv2 (see its own partnerIntroMessage), so this branch
        // never sees that partner anymore.
        if (partnerName === 'hs4cc') {
          return customIntroTextUlc;
        } else if (partnerName === 'starbucks' || partnerName === 'uber' || partnerName === 'google') {
          return customIntroTextEa;
        }
      }

      if (partnerName === 'welcome') {
        return !isULCDomain ? customIntroTextEa : customIntroTextUlc;
      }
      return ((this.$conn.partnerData || {}).welcomePageData || {}).introduction;
    }
  },

  computed: {
    welcomePageTitle() {
      const userStore = useUserStore();
      return userStore.welcomePageData.welcomePageTitle;
    }
  },

  created() {
    const userStore = useUserStore();
    if (userStore.welcomePageData.welcomePageTitle == undefined) this.fetchPartnerData();
    this.intro = this.introText();
  }
});
</script>
<style scoped></style>
